/**
 * Preset wall colors for the room-picker wizard.
 */

export type RoomWallColorId =
  | "white"
  | "offWhite"
  | "cream"
  | "beige"
  | "lightGray"
  | "warmGray"
  | "taupe"
  | "sand"
  | "lightBlue"
  | "skyBlue"
  | "sageGreen"
  | "oliveGreen"
  | "paleYellow"
  | "terracotta"
  | "dustyRose"
  | "lightBrown"
  | "charcoal"
  | "navyBlue"
  | "forestGreen"
  | "black";

export interface RoomWallColorOption {
  id: RoomWallColorId;
  /** i18n key under roomPicker.wallColors.* */
  labelKey: string;
  hex: string;
  /** THREE / wall fillColor as 0xRRGGBB */
  color: number;
}

const defineColor = (
  id: RoomWallColorId,
  hex: string,
): RoomWallColorOption => ({
  id,
  labelKey: id,
  hex,
  color: Number.parseInt(hex.replace("#", ""), 16),
});

export const ROOM_WALL_COLORS: RoomWallColorOption[] = [
  defineColor("white", "#FFFFFF"),
  defineColor("offWhite", "#F5F5F0"),
  defineColor("cream", "#FFFDD0"),
  defineColor("beige", "#E8DCC4"),
  defineColor("lightGray", "#D9D9D9"),
  defineColor("warmGray", "#B8B0A5"),
  defineColor("taupe", "#A89F91"),
  defineColor("sand", "#D8C3A5"),
  defineColor("lightBlue", "#BFD7EA"),
  defineColor("skyBlue", "#87CEEB"),
  defineColor("sageGreen", "#A8B5A2"),
  defineColor("oliveGreen", "#8A9A5B"),
  defineColor("paleYellow", "#F3E5AB"),
  defineColor("terracotta", "#C97C5D"),
  defineColor("dustyRose", "#C9A0A0"),
  defineColor("lightBrown", "#B89B7A"),
  defineColor("charcoal", "#36454F"),
  defineColor("navyBlue", "#1F3A5F"),
  defineColor("forestGreen", "#355E3B"),
  defineColor("black", "#000000"),
];

export const DEFAULT_ROOM_WALL_COLOR_ID: RoomWallColorId = "white";

export const getRoomWallColor = (
  id: RoomWallColorId,
): RoomWallColorOption =>
  ROOM_WALL_COLORS.find((option) => option.id === id) ?? ROOM_WALL_COLORS[0];
